import { render } from "./ObservationForm.vue?vue&type=template&id=76508cc7&scoped=true"
import script from "./ObservationForm.vue?vue&type=script&lang=js"
export * from "./ObservationForm.vue?vue&type=script&lang=js"

import "./ObservationForm.vue?vue&type=style&index=0&id=76508cc7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76508cc7"]])

export default __exports__